import instance from './instance';

export const fetchWorkspaceMeetings = (uuid, params) =>
  instance.get(`/workspaces/${uuid}/workspace_meetings`, { params });

export const fetchWorkspaceMeetingSnapshot = (uuid, snapshot_uuid) =>
  instance.get(`/workspaces/${uuid}/workspace_meetings/${snapshot_uuid}/snapshot_data`);
